<template>
  <!-- 立即支付 -->
  <div class="equipDetails">
    <div class="details_content" style="margin-bottom: 80px">
      <div class="details_left">
        <div class="appoint_name">
          <span style="color: #4d6fff">预约：</span>
          {{dataForm.equipmentName}}
        </div>
        <!-- 支付详情 -->
        <payPage  ref="pay" :isTeamShop="isTeamShop" @getTotalCost="getTotalCost" @changeButtonStatus="changeButtonStatus"></payPage>
         <!-- 微信支付弹窗 -->
        <we-chat-pay @creatOrder="creatOrder" @closeWxPay="closeWxPay" :wxPayInfo="wxPayInfo" v-if="weChatPayStatus"></we-chat-pay>
        <!-- 支付宝支付弹窗 -->
        <alipay @creatALiPayOrder="creatALiPayOrder" @closeALiPayOrder="closeALiPayOrder" v-if="aliPayStatus" ref="alipay" :aliPayOrder="aliPayOrder"></alipay>
        <!-- 底部合计 -->
        <div
          class="buffet-total-box"
          :style="{bottom: positionBottom}">
          <div class="buffet-total">
            <div class="clearfloat">
              <el-popover placement="top-start" width="500" trigger="hover">
              <buffetList :buffetList="buffetList" :listOrderPay="true" :dataForm="dataForm"></buffetList>
              <div class="b_price_detail fl" slot="reference">
                合计费用
                <span
                  class="redColor"
                  style="font-size: 30px;padding-left: 20px"
                >¥{{appointForm.totalCost}}</span>
                <span class="showDetail" v-if="appointForm.bargainStatus != 2">
                  费用明细
                  <span  class="detail_icon">
                    <i class="el-icon-arrow-up"></i>
                  </span>
                </span>
              </div>
              </el-popover>
              <div class="fr">
                <el-button type="primary" style="margin-right: 20px; padding: 12px 24px;" :disabled="button_status" :loading="loading_submit" @click="submitHandle()">确认支付</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="details_right">
        <div class="descicon"></div>
        <span class="right_title">技术顾问</span>
        <div class="technical">
         <el-image
            :src="dataForm.qrCodeFileList && dataForm.qrCodeFileList.length > 0 ? imgurl + dataForm.qrCodeFileList[0].url : '../../assets/img/morentupian.png' "
            class="lxfs"
          >
            <div slot="error">
              <img class="lxfs" src="../../assets/img/morentupian.png" />
            </div>
          </el-image>
          <br />{{dataForm.technicalAdvisorTextPrompts || '暂无提示文字'}}
        </div>
      </div>
    </div>
    <!-- 预约成功弹框 -->
    <appointSuccess ref="appointStatus" :form="appointForm" v-if="appointSuccessVisible"></appointSuccess>
  </div>
</template>
<script>
import { equipInfo,equipmentSubscribeAdd,orderInfo,createWXOrder,ZFBPreorderAction, checkPayStatus } from "@/api/request";
import payPage from "./payPage"
import buffetList from "./buffetList"
import appointSuccess from "./appointSuccess";
import weChatPay from "./WeChatPayPop.vue"
import { getClient } from '@/plugins/auth';
import Alipay from "./Alipay.vue"
export default {
  components: { payPage,buffetList,appointSuccess,weChatPay,Alipay },
  data() {
    return {
      isTeamShop: false,
      imgurl: process.env.VUE_APP_FILE_API,
      button_status: false,//支付按钮状态
      noticeVisible: true,
      appointSuccessVisible: false,
      currentIndex: 1,
      isShow: true,
      showDetail: true,
      userInfo: JSON.parse(getClient()),
      calendarVisible: false,
      loading_submit: false,//提交按钮是否正在被触发
      dataForm: {},
      weChatPayStatus: false, //微信支付弹窗状态
      aliPayStatus: false, // 支付宝支付状态
      wxPayInfo:null, //微信支付信息
      aliPayOrder: null, //支付宝支付信息
      appointForm: {},
      form: {},
      positionBottom: "0px",
      buffetList: [],
      orderBuffet: {
        sampleName: '优惠费用',
        totalPrice: '',
        sumText: '',
        subChargeVOList: [
          {
            buffName: '个人折扣',
            buffValue: '100%',
            totalPrice: '100%'
          },
          {
            buffName: '优惠券',
            buffValue: '0',
            totalPrice: 0
          },
          {
            buffName: '赠送金',
            buffValue: '0',
            totalPrice: 0
          }
        ]
      },
    };
  },
  mounted() {
    this.getInfo();
    this.getOrderInfo()
    window.addEventListener("scroll", this.handleScroll, true); // 监听（绑定）滚轮滚动事件
  },
  methods: {
    async getInfo() {
      const res = await equipInfo(this.$route.query.id)
      this.dataForm = res.data
      this.isTeamShop = Boolean(res.data.isGroupBuy)
    },
    async getOrderInfo () {
      const res = await orderInfo(this.$route.query.orderId)
      this.appointForm = {
        ...res.data,
      }
      this.$refs.pay.init(res.data)
      this.appointForm.globalFieldValues = res.data.equipmentSubscribe.globalFieldValues
      this.buffetList = res.data.expenseDetailList || []
      // this.updateDetectionTotal(res.data.equipmentSubscribe)
    },
    // updateDetectionTotal(info) {
    //   // unitPrice单价 totalPrice根据不同计算方式的字段金额
    //   if (info.groups.length > 0) {
    //     this.buffetList = info.groups.map(i => {
    //       const totalList = [];
    //       let fieIdList = i.values.filter(j => {
    //         // 单选、多选、元素周期表要计算价格
    //         return j.fieIdType == 1 || j.fieIdType == 2 || (j.fieIdType == 10 && j.fieIdValue != '');
    //       });
    //       fieIdList.map(k => {
    //         //元素周期表情况
    //         if (k.fieIdType == 10) {
    //           totalList.push({ ...k });
    //         }
    //         // 单选、多选情况/根据valueId选择的选项id找到对应选项
    //         if (k.valueId) {
    //           k.valueId = k.valueId.split(',')  
    //           k.options.map(m => {
    //             k.valueId.map(n => {
    //               if (m.optionId == n) {
    //                 totalList.push({
    //                   ...m,
    //                   fieIdName: k.fieIdName,
    //                   calculateWay: k.calculateWay,
    //                   fieIdType: k.fieIdType
    //                 });
    //               }
    //             });
    //           });
    //         }
    //       });
    //       var map = {},dest = [];
    //       totalList.map(total => {
    //         // 单选、多选金额
    //         if (total.fieIdType == 1 || total.fieIdType == 2) {
    //           // 根据价格计算方式处理字段(calculateWay)价格
    //           // 1 按样品数量 2 按预约时长 3 固定价格 4 不计算价格(3,4无需计算，2只有云设备需要)
    //           if (total.calculateWay == 1) {
    //             total.totalPrice = Number(total.unitPrice) * Number(i.specimenNum);
    //           } else if ( total.calculateWay == 2 && this.dataForm.isCloudScene == 1) {
    //               total.totalPrice = Number(total.unitPrice) * Number(this.appointForm.duration)
    //               total.appointHours = Number(this.appointForm.duration)
    //           }else if (total.calculateWay == 4) { 
    //             total.unitPrice = 0
    //             total.totalPrice = 0
    //           }
    //           else {
    //             total.totalPrice = total.unitPrice;
    //           }
    //         } else {
    //           // 元素周期表金额
    //           if (total.fieIdValue != '') {
    //             let list = total.fieIdValue.split(',')
    //             total.unitPrice = Number(total.elementPrice) * Number(list.length)
    //             total.totalPrice = total.unitPrice  * Number(i.specimenNum)
    //           }
    //         }
    //         //字段多选时合并金额
    //         if (!map[total.fieIdId]) {
    //             dest.push(total);
    //             map[total.fieIdId] = total;
    //           } else {
    //             dest.map(j => {
    //               if (total.fieIdId == j.fieIdId) {
    //                 j.unitPrice = Number(j.unitPrice) + Number(total.unitPrice);
    //                 j.totalPrice = Number(j.totalPrice) + Number(total.totalPrice);
    //               }
    //             });
    //           }
    //       });
    //       //计算单个样品的总金额
    //       i.totalMomey = this.getTotalMoney(dest,'totalPrice')
    //       return { ...i, subChargeVOList: dest };
    //     });
    //     this.$forceUpdate()
    //   }
    // },
    //获取待支付页面信息
    getTotalCost (info) {
      this.appointForm = {
        ...this.appointForm,
        ...info,
        activityId: this.isTeamShop ? this.dataForm.groupBuyActivityId : undefined
      }
      this.orderBuffet.sumText = ''
      if (this.appointForm.discountType == 1) {
          this.orderBuffet.subChargeVOList[0].buffName = '个人折扣'
          this.orderBuffet.subChargeVOList[0].buffValue = this.userInfo.discountRate + '%'
          this.orderBuffet.subChargeVOList[0].totalPrice = `-￥${this.appointForm.originalPrice * ((100 - this.userInfo.discountRate) / 100)}`
          this.orderBuffet.sumText = this.orderBuffet.sumText + this.appointForm.originalPrice + '*' + this.userInfo.discountRate + '%'
      } else if(this.appointForm.discountType == 2) {
          this.orderBuffet.subChargeVOList[0].buffName = '团队折扣'
          this.orderBuffet.subChargeVOList[0].buffValue = this.userInfo.discountRateTeam + '%'
          this.orderBuffet.subChargeVOList[0].totalPrice = `-￥${this.appointForm.originalPrice * ((100 - this.userInfo.discountRateTeam) / 100)}`
          this.orderBuffet.sumText = this.orderBuffet.sumText + this.appointForm.originalPrice + '*' + this.userInfo.discountRateTeam + '%'
      } else {
          this.orderBuffet.subChargeVOList[0].buffName = '暂无折扣'
          this.orderBuffet.subChargeVOList[0].buffValue = ''
          this.orderBuffet.subChargeVOList[0].totalPrice = '暂无折扣'
          this.orderBuffet.sumText = this.orderBuffet.sumText + this.appointForm.originalPrice
      }
      if (this.appointForm.ifUrgent === 1) {
          this.orderBuffet.sumText = this.orderBuffet.sumText + '+' + this.appointForm.originalPrice * 0.5
      }
      if (this.appointForm.ifRecycle === 1) {
          if (this.userInfo.whiteFlag !== 1 || this.userInfo.recoveryFree !== 1) {
              this.orderBuffet.sumText = this.orderBuffet.sumText + '+50'
          }
      }
      if (this.appointForm.postMethod == 1) {
          if (this.appointForm.postPayment === 2) {
          } else {
              this.orderBuffet.sumText = this.orderBuffet.sumText + '+12'
          }
      }
      if (this.appointForm.couponMoney >= 0) {
          this.orderBuffet.subChargeVOList[1].buffValue = `￥${this.appointForm.couponMoney}`
          this.orderBuffet.subChargeVOList[1].totalPrice = `- ￥${this.appointForm.couponMoney}`
          this.orderBuffet.sumText = this.orderBuffet.sumText + '-' + this.appointForm.couponMoney
      }
      if (this.appointForm.cashCoupon >= 0) {
          this.orderBuffet.subChargeVOList[2].buffValue = `￥${this.appointForm.cashCoupon}`
          this.orderBuffet.subChargeVOList[2].totalPrice = `- ￥${this.appointForm.cashCoupon}`
          this.orderBuffet.sumText = this.orderBuffet.sumText + '-' + this.appointForm.cashCoupon
      }
      this.orderBuffet.totalPrice = this.appointForm.totalCost
      const hasOrderDiscount = this.appointForm.expenseDetailList.some((item) => item.sampleName.includes('优惠费用'))
      if (hasOrderDiscount) {
          this.appointForm.expenseDetailList[this.appointForm.expenseDetailList.length - 1] = this.orderBuffet
      } else {
          this.appointForm.expenseDetailList.push(this.orderBuffet)
      }
    },
    async submitHandle () {
      if (!this.appointForm.prepaidPayment || this.appointForm.prepaidPayment == '') {
        return this.$message.warning("请选择支付方式");
      }
      this.loading_submit = true
      const res = await checkPayStatus(this.appointForm.subscribeId)
      // status == 1为待支付状态
      if(res.data.status != 1) {
        this.$alert('该订单状态已发生改变！', '温馨提示', {
          confirmButtonText: '确定',
          showClose: false,
          callback: () => {
            this.$router.push('/')
          }
        })
      } else {
        this.appointForm.equipmentSubscribe.groups.map(i=> {
          i.values.map(j=> {
            j.fieIdValue = j.fieIdValue ? j.fieIdValue.toString() : ''
            j.valueId = j.valueId?j.valueId.toString(): ''
          })
        })
        //费用明细
        this.buffetList.map(i=> {
          i.subChargeVOList.map(j=> {
            j.quantity = i.specimenNum
            j.price = j.unitPrice
          })
          i.originalPrice = i.totalMoney
        })
        let obj = {
          ...this.appointForm,
          groups: this.appointForm.equipmentSubscribe.groups,//详情返回在equipmentSubscribe里面，提交时需要放到外面
          expenseDetailList: this.buffetList,
          status: 2,
        }
        // 0 元订单仍允许确认支付，但无需创建第三方扫码支付订单。
        if(Number(obj.totalCost) === 0 && (this.appointForm.prepaidPayment == 3 || this.appointForm.prepaidPayment == 4)){
          equipmentSubscribeAdd(obj).then(res=> {
            this.appointSuccessVisible = true;
            this.$nextTick(()=> {
              this.$refs.appointStatus.init()
            })
          }).finally(() => {
            this.loading_submit = false
          })
          return
        }
        //如果支付方式选择支付宝/微信需要弹出对应付款弹框
        if(this.appointForm.prepaidPayment == 4){
          let orderInfo = {
            subscribeId: this.appointForm.subscribeId,
            totalPrice: this.appointForm.totalCost * 100, //后端金额单位为分 需要乘以100换算为分
            goodsName: this.dataForm.equipmentName, //商品描述 取得设备名称
            notifyUrl: process.env.VUE_APP_PAY_API, //回调地址 通知url必须为外网可访问的url，不能携带参数。 公网域名必须为https，如果是走专线接入，使用专线NAT IP或者私有回调域名可使用http
          }
          createWXOrder(orderInfo).then(res => {
            this.wxPayInfo = res.data
            this.wxPayInfo.totalCost = this.appointForm.totalCost
            this.wxPayInfo.orderId = this.appointForm.orderId,//订单ID
            this.weChatPayStatus = true
            this.wxPayInfo.subscribeId = this.appointForm.subscribeId
          }).finally(() => {
            this.loading_submit = false
          })
        }else if(this.appointForm.prepaidPayment == 3){
          let orderInfo = {
            subscribeId: this.appointForm.subscribeId,
            price: this.appointForm.totalCost, //单位是元
            goodsName: this.dataForm.equipmentName, //商品描述 取得设备名称
            notifyUrl: process.env.VUE_APP_PAY_API, //回调地址 通知url必须为外网可访问的url，不能携带参数。 公网域名必须为https，如果是走专线接入，使用专线NAT IP或者私有回调域名可使用http
          }
          ZFBPreorderAction(orderInfo).then(res => {
            this.aliPayOrder = {
              barcodeText: res.data.body,
              orderCode: res.data.orderCode,
              orderId: this.appointForm.orderId,//订单ID
              subscribeId: this.appointForm.subscribeId,
              price: this.appointForm.totalCost,
              goodsName: this.dataForm.equipmentName
            }
            this.aliPayStatus = true
            this.$nextTick(() => {
              this.$refs.alipay.init(this.aliPayOrder)
            })
          }).catch(err => {
          }).finally(() => {
            this.loading_submit = false
          })
        }else{
          //其他的直接提交
          equipmentSubscribeAdd(obj).then(res=> {
            this.appointSuccessVisible = true;
            this.$nextTick(()=> {
              this.$refs.appointStatus.init()
            })
          }).finally(() => {
            this.loading_submit = false
          })
        }
      }
    },
    //关闭微信支付弹窗
    closeWxPay(e){
      this.wxPayInfo = null
      this.weChatPayStatus = false
      if(e){
        this.$router.push({
              path: "/aboutUsIndex",
              query: {type: 13, tabIndex: '2-1',tabName: '我的订单' }
            });
      }
    },
    //微信支付成功 创建预约订单
    creatOrder(){
      this.wxPayInfo = null
      this.weChatPayStatus = false
      let obj = {
          ...this.appointForm,
          groups: this.appointForm.equipmentSubscribe.groups,//详情返回在equipmentSubscribe里面，提交时需要放到外面
          expenseDetailList: this.buffetList,
          status: 2
        }
      // 其他的直接提交
        equipmentSubscribeAdd(obj).then(res=> {
          this.appointSuccessVisible = true;
          this.$nextTick(()=> {
            this.$refs.appointStatus.init()
          })
        })
    },
    //关闭支付宝支付订单
    closeALiPayOrder(e){
      this.aliPayOrder = null
      this.aliPayStatus = false
      if(e){
        this.$router.push({
              path: "/aboutUsIndex",
              query: {type: 13, tabIndex: '2-1',tabName: '我的订单' }
            });
      }
    },
    //支付宝支付完成创建预约订单
    creatALiPayOrder(){
      this.aliPayOrder = null
      this.aliPayStatus = false

      let obj = {
        ...this.appointForm,
        groups: this.appointForm.equipmentSubscribe.groups,//详情返回在equipmentSubscribe里面，提交时需要放到外面
        expenseDetailList: this.buffetList,
        status: 2
      }
      // 其他的直接提交
        equipmentSubscribeAdd(obj).then(res=> {
          this.appointSuccessVisible = true;
          this.$nextTick(()=> {
            this.$refs.appointStatus.init()
          })
        })
    },
    handleScroll(e) {
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      const scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      const clientHeight =
        document.documentElement.clientHeight || window.innerHeight;
      if (scrollHeight - (scrollTop + clientHeight) > 347) {
        this.positionBottom = "0px";
      }
      if (scrollHeight - (scrollTop + clientHeight) < 347) {
        this.positionBottom =
          347 - (scrollHeight - (scrollTop + clientHeight)) + "px";
      }
    },
    //控制支付按钮状态
    changeButtonStatus(value) {
      this.button_status = value
      if(value) {
        this.$message.closeAll()
        this.$message.warning('低于0元的订单无法使用现金支付', 1000)
      }
    },
  }
};
</script>
<style scoped lang="scss">
.appoint_name {
  font-weight: 500;
  color: #333;
  font-size: 26px;
  margin-bottom: 20px;
  margin-top: 20px;
}
.details_box-card {
  margin-bottom: 30px;
}
.details_img_box {
  border-radius: 8px;
  width: 300px;
  background: #fff;
  text-align: center;
  margin-top: 10px;
  margin-bottom: 15px;
}
.right_details_img {
  width: 220px;
  height: 220px;
  border-radius: 13px;
  margin: 20px auto;
}
.testingInstructions {
  max-height: 300px;
  overflow: hidden;
  overflow-y: scroll;
}
.clearfix {
  position: relative;
}
.isShow {
  cursor: pointer;
  position: absolute;
  right: 15px;
  top: -5px;
  font-size: 26px;
}
.buffet-total-box {
  position: fixed;
  z-index: 2000;
  left: 0;
  width: 100%;
  background: transparent;
  transition: all 0.05s linear;
}
.buffet-total {
  position: relative;
  width: 80%;
  margin: 0 auto;
  background: transparent;
  .b_price_detail {
    float: left;
    display: flex;
    align-items: center;
    min-height: 68px;
    font-size: 16px;
    padding-left: 20px;
    border-left: 6px solid #4d6ffe;
    border-radius: 4px;
  }
}
.clearfloat {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background: #fff;
  box-shadow: 0 -3px 6px 0px rgba(0, 0, 0, 0.08);
  border-radius: 5px;
  // padding: 0 20px;
}
.buffet-section {
  line-height: 25px;
  background: #fff;
  margin-bottom: 10px;
}
.showDetail {
  padding-left: 20px;
  cursor: pointer;
  font-size: 16px;
  color: #4d6ffe;
}
.showDetail:hover {
  color: #409eff;
}
</style>